import {observer} from 'mobx-react';
import React from 'react';
import {PromiseMessage} from '../../../../lib/components';
import {X1LanguageStore} from '../X1LanguageStore';

@observer
export class DeleteAgeCategoryControls extends React.Component<{ store: X1LanguageStore }> {
  render() {
    const {store} = this.props;

    if (store.deleteAgeCategory === null)
      return null;

    const deleteAgeCategory = store.deleteAgeCategory;
    const isFailure = deleteAgeCategory.save?.isRejected === true;

    return (<>
      <PromiseMessage label="Deleting"
                      state={deleteAgeCategory.save}
                      align="right"/>
      {
        isFailure &&
        <div className="row justify-content-end">
          <div className="col-auto">
            <button type="button" className="btn btn-primary"
                    onClick={() => store.beginDelete(deleteAgeCategory.ageCategoryId)}> Retry
            </button>
            <button type="button" className="btn btn-primary"
                    onClick={store.cancel}> Cancel
            </button>
          </div>
        </div>
      }
    </>);
  }
}
